import React from 'react';
import { Check, Layout, Search, User } from '@saleshandy/icons';
import {
  LINKEDIN_COMPANY_URL,
  LINKEDIN_PERSON_URL,
  SALES_NAVIGATOR_LEAD_PROFILE_URL,
} from './constants';

type IProps = {
  creditGiven: boolean;
};

// Eight confetti particles burst from the success check. Their positions,
// delays and colors live in _lead-finder-extension-modal.scss (the --cN
// modifier classes) — this list only drives how many render.
const CONFETTI_COUNT = 8;

const TRY_IT_CARDS = [
  {
    href: LINKEDIN_PERSON_URL,
    label: 'Person profile',
    platform: 'LinkedIn',
    Icon: User,
  },
  {
    href: LINKEDIN_COMPANY_URL,
    label: 'Company page',
    platform: 'LinkedIn',
    Icon: Layout,
  },
  {
    href: SALES_NAVIGATOR_LEAD_PROFILE_URL,
    label: 'Lead Profile',
    platform: 'Sales Navigator',
    Icon: Search,
  },
];

const FinishStep: React.FC<IProps> = ({ creditGiven }) => (
  <div className="bs-lf-ext__finish">
    <span className="bs-lf-ext__finish-popper" aria-hidden>
      {Array.from({ length: CONFETTI_COUNT }, (_, i) => (
        <span
          key={`confetti-${i + 1}`}
          className={`bs-lf-ext__finish-confetti bs-lf-ext__finish-confetti--c${
            i + 1
          }`}
        />
      ))}
      <span className="bs-lf-ext__finish-check">
        <Check width={22} height={22} className="green-txt-6" />
      </span>
    </span>

    <h3 className="bs-lf-ext__finish-title semibold-5 gray-txt-9">
      You&apos;re all set!
    </h3>

    {!creditGiven && (
      <p className="bs-lf-ext__finish-copy regular-3 gray-txt-11">
        <span className="semibold-3 blue-txt-6">50 free credits</span> will be
        added to your account when you log in to the extension.
      </p>
    )}

    <p className="bs-lf-ext__finish-prompt semibold-2 gray-txt-9">
      Open a page to try it now:
    </p>

    <div className="bs-lf-ext__finish-cards">
      {TRY_IT_CARDS.map(({ href, label, platform, Icon }) => (
        <a
          key={label}
          className="bs-lf-ext__finish-card"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="bs-lf-ext__finish-card-icon">
            <Icon width={18} height={18} />
          </span>
          <span className="semibold-2 gray-txt-9">{label}</span>
          <span className="regular-1 gray-txt-11">{platform}</span>
        </a>
      ))}
    </div>
  </div>
);

export default FinishStep;
